/**
 * Prefix a public/ path with Vite's `base` so assets resolve under nginx
 * mounts like `/platform/` or at site root when `base` is `/` or `""`.
 * Path segments are encoded so spaces and special characters work behind
 * reverse proxies.
 *
 * Always returns a root-absolute path (leading `/`) when base is empty,
 * so nested routes like `/undergraduate` do not resolve assets relatively.
 *
 * @example assetUrl("/assets/img/logo.png") → "/platform/assets/img/logo.png"
 * @example assetUrl("/assets/pdf/UG_FAQs.pdf") → "/assets/pdf/UG_FAQs.pdf"
 */
export function assetUrl(path: string): string {
  const base = import.meta.env.BASE_URL || "/"
  const normalizedBase = base.endsWith("/") ? base : `${base}/`
  const clean = path.replace(/^\//, "")
  const encoded = clean
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/")
  return `${normalizedBase}${encoded}`
}
